function setValue(element: HTMLInputElement, value: any): void {
    // If value is function
    if (typeof value === 'function') {
        value = value();
    }

    // Set value
    element.value = value;
}

// ----------------------------------------------------------------------------

function report(elements: HTMLElement | HTMLElement[], config: Record<string, any> = {}): void {
    if (!Array.isArray(elements)) {
        elements = [elements] as HTMLElement[];
    }

    // Foreach Elements
    for (const element of elements) {
        // Get element (form group)
        const elFormGroup = element.closest('.form-group');
        // If there is element (form group)
        if (elFormGroup) {
            /* addClass(elFormGroup, 'has-error'); */
        }
        // Is default
        else {
            /* addClass(element, 'has-error'); */
        }
    }
}

// ----------------------------------------------------------------------------

export { report, setValue };
